if (!customElements.get('hc-rc-parts-finder')) customElements.define('hc-rc-parts-finder', class extends HTMLElement {
 connectedCallback() {
  this.controller?.abort(); this.controller = new AbortController();
  const signal = this.controller.signal, form = this.querySelector('form'), brand = this.querySelector('[data-rc-brand]');
  form.addEventListener('submit', event => {
   event.preventDefault(); if (!form.reportValidity()) return;
   const url = new URL(form.action, location.origin);
   if(url.origin !== location.origin) return;
   url.searchParams.set('filter.p.vendor', brand.value);  url.searchParams.delete('page'); url.searchParams.delete('hc_page'); url.hash = 'products';
   const preview = new URL(location.href).searchParams.get('preview_theme_id') || document.body.dataset.hcPreviewTheme;
   if(preview) url.searchParams.set('preview_theme_id', preview);
   location.assign(url.href);
  }, {signal});
 }
 disconnectedCallback(){ this.controller?.abort(); }
});
